{
  "title": "Pago de tasas",
  "subTitle": "Seleccione una cuenta no registrada para retirar las comisiones",
  "currentAccount": "(cuenta corriente)"
}
